var data = {

    US:
    {
        "Texas ": 3775,
        "Gulf of Mexico ": 1407,
        "North Dakota ": 1191,
        "California ": 560,
        "Alaska ": 511,
        "New Mexico ": 420,
        "Oklahoma ": 374,
        "Colorado ": 323,
        "Wyoming ": 247,
        "Louisiana ": 180,
        "Kansas ": 138,
        "Utah ": 112,
        "Montana ": 88,
        "Mississippi ": 73,
        "Ohio ": 70,
        "West Virginia ": 38,
        "Alabama ": 29,
        "Illinois ": 24,
        "Pennsylvania ": 21,
        "Michigan ": 18,
        "Arkansas ": 18,
        "Nebraska ": 8,
        "Indiana ": 6,
        "Florida ": 5,
        "South Dakota ": 5,
        "Kentucky ": 4,
        "Tennessee ": 1,
        "New York ": 1,
        "Nevada ": 1,
        "Missouri ": 1,
        "Arizona ": 1,
        "Virginia ": 1
    },
    world:[
        ["Bermuda",0,0],
        ["Canada",0,3911],
        ["Greenland",0,0],
        ["Mexico",0,2356],
        ["Saint Pierre and Miquelon",0,0],
        ["United States",0,9692],
        ["Central & South America",0,7239],
        ["Antarctica",0,0],
        ["Antigua and Barbuda",0,0],
        ["Argentina",0,531],
        ["Aruba",0,0],
        ["Bahamas, The",0,0],
        ["Barbados",0,1],
        ["Belize",0,2],
        ["Bolivia",0,51],
        ["Brazil",0,2413],
        ["Cayman Islands",0,0],
        ["Chile",0,6],
        ["Colombia",0,965],
        ["Costa Rica",0,0],
        ["Cuba",0,50],
        ["Dominica",0,0],
        ["Dominican Republic",0,0],
        ["Ecuador",0,553],
        ["El Salvador",0,0],
        ["Falkland Islands (Islas Malvinas)",0,0],
        ["French Guiana",0,0],
        ["Grenada",0,0],
        ["Guadeloupe",0,0],
        ["Guatemala",0,10],
        ["Guyana",0,0],
        ["Haiti",0,0],
        ["Honduras",0,0],
        ["Jamaica",0,0],
        ["Martinique",0,0],
        ["Montserrat",0,0],
        ["Netherlands Antilles",0,0],
        ["Nicaragua",0,0],
        ["Panama",0,0],
        ["Paraguay",0,0],
        ["Peru",0,62],
        ["Puerto Rico",0,0],
        ["Saint Kitts and Nevis",0,0],
        ["Saint Lucia",0,0],
        ["Saint Vincent/Grenadines",0,0],
        ["Suriname",0,15],
        ["Trinidad and Tobago",0,81],
        ["Turks and Caicos Islands",0,0],
        ["Uruguay",0,0],
        ["Venezuela",0,2500],
        ["Virgin Islands,  U.S.",0,0],
        ["Virgin Islands, British",0,0],
        ["Europe",0,3048],
        ["Albania",0,22],
        ["Austria",0,17],
        ["Belgium",0,0],
        ["Bosnia and Herzegovina",0,0],
        ["Bulgaria",0,1],
        ["Croatia",0,12],
        ["Cyprus",0,0],
        ["Czech Republic",0,3],
        ["Denmark",0,153],
        ["Faroe Islands",0,0],
        ["Finland",0,0],
        ["Former Czechoslovakia",0,0],
        ["Former Serbia and Montenegro",0,0],
        ["Former Yugoslavia",0,0],
        ["France",0,15],
        ["Germany",0,46],
        ["Germany (Offshore)",0,1],
        ["Germany, East",0,0],
        ["Germany, West",0,0],
        ["Gibraltar",0,0],
        ["Greece",0,1],
        ["Hungary",0,12],
        ["Iceland",0,0],
        ["Ireland",0,0],
        ["Italy",0,97],
        ["Kosovo",0,0],
        ["Luxembourg",0,0],
        ["Macedonia",0,0],
        ["Malta",0,0],
        ["Montenegro",0,0],
        ["Netherlands",0,8],
        ["Netherlands (Offshore)",0,22],
        ["Norway",0,1595],
        ["Poland",0,19],
        ["Portugal",0,0],
        ["Romania",0,82],
        ["Serbia",0,18],
        ["Slovakia",0,0.2],
        ["Slovenia",0,0],
        ["Spain",0,5],
        ["Sweden",0,0],
        ["Switzerland",0,0],
        ["Turkey",0,47],
        ["United Kingdom",0,22],
        ["United Kingdom (Offshore)",0,849],
        ["Eurasia",0,12940],
        ["Armenia",0,0],
        ["Azerbaijan",0,847],
        ["Belarus",0,26],
        ["Estonia",0,0],
        ["Former U.S.S.R.",0,0],
        ["Georgia",0,1],
        ["Kazakhstan",0,1660],
        ["Kyrgyzstan",0,1],
        ["Latvia",0,0],
        ["Lithuania",0,2],
        ["Moldova",0,0],
        ["Russia",0,10050],
        ["Tajikistan",0,0.2],
        ["Turkmenistan",0,240],
        ["Ukraine",0,38],
        ["Uzbekistan",0,75],
        ["Middle East",0,25159],
        ["Bahrain",0,50],
        ["Iran",0,3300],
        ["Iraq",0,3825],
        ["Israel",0,0.4],
        ["Jordan",0,0],
        ["Kuwait",0,2650],
        ["Lebanon",0,0],
        ["Oman",0,977],
        ["Palestinian Territories",0,0],
        ["Qatar",0,1503],
        ["Saudi Arabia",0,9940],
        ["Syria",0,26],
        ["United Arab Emirates",0,2820],
        ["Yemen",0,68],
        ["Africa",0,7927],
        ["Algeria",0,1370],
        ["Angola",0,1760],
        ["Benin",0,0],
        ["Botswana",0,0],
        ["Burkina Faso",0,0],
        ["Burundi",0,0],
        ["Cameroon",0,73],
        ["Cape Verde",0,0],
        ["Central African Republic",0,0],
        ["Chad",0,94],
        ["Comoros",0,0],
        ["Congo (Brazzaville)",0,256],
        ["Congo (Kinshasa)",0,20],
        ["Cote dIvoire (IvoryCoast)",0,33],
        ["Djibouti",0,0],
        ["Egypt",0,525],
        ["Equatorial Guinea",0,249],
        ["Eritrea",0,0],
        ["Ethiopia",0,0],
        ["Gabon",0,215],
        ["Gambia, The",0,0],
        ["Ghana",0,103],
        ["Guinea",0,0],
        ["Guinea-Bissau",0,0],
        ["Kenya",0,0],
        ["Lesotho",0,0],
        ["Liberia",0,0],
        ["Libya",0,475],
        ["Madagascar",0,0],
        ["Malawi",0,0],
        ["Mali",0,0],
        ["Mauritania",0,6],
        ["Mauritius",0,0],
        ["Morocco",0,0.1],
        ["Mozambique",0,0],
        ["Namibia",0,0],
        ["Niger",0,20],
        ["Nigeria",0,2420],
        ["Reunion",0,0],
        ["Rwanda",0,0],
        ["Saint Helena",0,0],
        ["Sao Tome and Principe",0,0],
        ["Senegal",0,0],
        ["Seychelles",0,0],
        ["Sierra Leone",0,0],
        ["Somalia",0,0],
        ["South Africa",0,3],
        ["Sudan and South Sudan",0,257],
        ["Swaziland",0,0],
        ["Tanzania",0,0],
        ["Togo",0,0],
        ["Tunisia",0,47],
        ["Uganda",0,0],
        ["Western Sahara",0,0],
        ["Zambia",0,0],
        ["Zimbabwe",0,0],
        ["Asia & Oceania",0,7885],
        ["Afghanistan",0,0],
        ["American Samoa",0,0],
        ["Australia",0,328],
        ["Bangladesh",0,4],
        ["Bhutan",0,0],
        ["Brunei",0,111],
        ["Burma (Myanmar)",0,15],
        ["Cambodia",0,0],
        ["China",0,4254],
        ["Cook Islands",0,0],
        ["Fiji",0,0],
        ["French Polynesia",0,0],
        ["Guam",0,0],
        ["Hawaiian Trade Zone",0,0],
        ["Hong Kong",0,0],
        ["India",0,776],
        ["Indonesia",0,805],
        ["Japan",0,5],
        ["Kiribati",0,0],
        ["Korea, North",0,0],
        ["Korea, South",0,0],
        ["Laos",0,0],
        ["Macau",0,0],
        ["Malaysia",0,697],
        ["Maldives",0,0],
        ["Mongolia",0,23],
        ["Nauru",0,0],
        ["Nepal",0,0],
        ["New Caledonia",0,0],
        ["New Zealand",0,34],
        ["Niue",0,0],
        ["Pakistan",0,95],
        ["Papua New Guinea",0,49],
        ["Philippines",0,22],
        ["Samoa",0,0],
        ["Singapore",0,0],
        ["Solomon Islands",0,0],
        ["Sri Lanka",0,0],
        ["Taiwan",0,0.2],
        ["Thailand",0,255],
        ["Timor-Leste (East Timor)",0,75],
        ["Tonga",0,0],
        ["U.S. Pacific Islands",0,0],
        ["Vanuatu",0,0],
        ["Vietnam",0,336],
        ["Wake Island",0,0],
        ["World",0,79996]
    ],
    position: {
        "Canada": {
            top: 50,
            left: 113
        },
        "Mexico": {
            top: 140,
            left: 113
        },
        "United States": {
            top: 100,
            left: 163
        },
        "Argentina": {
            top: 260,
            left: 193
        },
        "Brazil": {
            top: 200,
            left: 203
        },
        "Colombia": {
            top: 180,
            left: 173
        },
        "Ecuador": {
            top: 190,
            left: 163
        },
        "Peru": {
            top: 210,
            left: 163
        },
        "Venezuela": {
            top: 180,
            left: 193
        },
        "Denmark": {
            top: 70,
            left: 323
        },
        "Germany": {
            top: 100,
            left: 323
        },
        "Italy": {
            top: 130,
            left: 323
        },
        "Norway": {
            top: 50,
            left: 323
        },
        "United Kingdom": {
            top: 80,
            left: 283
        },
        "Kazakhstan": {
            top: 110,
            left: 403
        },
        "Russia": {
            top: 50,
            left: 473
        },
        "Turkmenistan": {
            top: 130,
            left: 393
        },
        "Iran": {
            top: 140,
            left: 383
        },
        "Iraq": {
            top: 140,
            left: 363
        },
        "Kuwait": {
            top: 140,
            left: 383
        },
        "Oman": {
            top: 160,
            left: 383
        },
        "Saudi Arabia": {
            top: 130,
            left: 373
        },
        "Algeria": {
            top: 150,
            left: 393
        },
        "Angola": {
            top: 210,
            left: 313
        },
        "Egypt": {
            top: 120,
            left: 353
        },
        "Libya": {
            top: 120,
            left: 333
        },
        "Nigeria": {
            top: 190,
            left: 303
        },
        "Australia": {
            top: 250,
            left: 523
        },
        "China": {
            top: 100,
            left: 503
        },
        "India": {
            top: 160,
            left: 433
        },
        "Indonesia": {
            top: 200,
            left: 483
        },
        "Malaysia": {
            top: 190,
            left: 463
        },
        "Thailand": {
            top: 170,
            left: 463
        },
        "Vietnam": {
            top: 190,
            left: 473
        }
    }

};

module.exports = data;


// WEBPACK FOOTER //
// ./src/components/dashboard/dotted-map-widget/oil_production_data.js